export default __webpack_public_path__ + "static/media/Chaitrali.28a02ffc.jpg";